import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { resetAuthReducer } from "shared/redux/reducers/authSlice";
import { disconnectSocket } from "shared/services/socket";
import { toastMessage } from "../../common/toast";
import { routeConstant } from "shared/routes/routeConstant";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Icons, Images } from "assets";
import classNames from "classnames";
import ConfirmationModal from "shared/modal/confirmation";
import NavItem from "./navItem";
import styles from "./style.module.scss";
import CustomButton from "shared/components/common/customButton";
interface Props {
  sidebarArr: SideBarItemsType[];
}
function DashboardSidebar({ sidebarArr }: Props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const auth = useSelector((state: any) => state.root.auth);
  const [openConfirmationModal, setOpenConfirmationModal] =
    useState<boolean>(false);

  const user = auth?.user || {};
  const display_name = user.display_name;
  const userType = user.user_type;

  const getUserInitials = () => {
    if (display_name) {
      const parts = display_name.trim().split(" ");
      if (parts.length >= 2) {
        return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(
          0,
        )}`.toUpperCase();
      } else if (parts.length === 1) {
        return parts[0].charAt(0).toUpperCase();
      }
    }
    return "U";
  };

  const getFormattedUserType = () => {
    const formattedType = userType
      ? userType.charAt(0).toUpperCase() + userType.slice(1).toLowerCase()
      : "";
    return formattedType ? `${formattedType} Portal` : "Portal";
  };
  const handleOpenConfirmationModal = () => {
    setOpenConfirmationModal(true);
  };
  const handleCloseConfirmationModal = () => {
    setOpenConfirmationModal(false);
  };
  const handleLogout = () => {
    disconnectSocket();
    dispatch(resetAuthReducer());
    toastMessage("success", "Logged out successfully");
    navigate(routeConstant.login.path);
  };
  return (
    <div
      className={classNames(
        styles.sidebarWrapper,
        "flex flex-col justify-between",
      )}
    >
      <div className="text-center w-full flex flex-col items-start bg-white">
        <div className={classNames(styles.logoTopContainerFull, "w-full px-2")}>
          <div
            className={classNames(
              "flex items-center justify-center w-full",
              styles.logoContainer,
            )}
          >
            <Link
              to={
                location.pathname.includes("/client")
                  ? routeConstant.client.projects.path
                  : location.pathname.includes("/collaborator")
                    ? routeConstant.collaborator.projects.path
                    : location.pathname.includes("/builder")
                      ? routeConstant.builder.projects.path
                      : routeConstant.designer.allProjects.path
              }
              className={styles.logoLink}
            >
              <span className={styles.logoAnimationWrap}>
                <img
                  className={classNames(styles.mainLogo)}
                  width={81}
                  height={54}
                  src={Images.Logo}
                  alt="logo"
                />
              </span>
            </Link>
          </div>
        </div>
        <div
          className={classNames("flex flex-col justify-between h-full gap-3")}
        >
          <div
            className={classNames(styles.sideNavFull, "flex flex-col gap-1")}
          >
            {sidebarArr?.map((item, inx) => {
              return (
                <div className="flex flex-col items-start gap-1" key={inx}>
                  <label className={classNames(styles.navTitle)}>
                    {item?.title}
                  </label>
                  <div className="w-full flex flex-col gap-0">
                    {item?.paths?.map(
                      (s: SideBarItemPathType, s_inx: number) => {
                        const props = {
                          ...s,
                        };
                        return <NavItem {...props} key={s_inx} />;
                      },
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div
        className={classNames(
          styles.bottomContainer,
          "w-full flex flex-col gap-3",
        )}
      >
        <div className={classNames(styles.supportContainerWrapper)}>
          {(location.pathname.includes("/client") ||
            location.pathname.includes("/collaborator")) && (
            <div
              className={classNames(
                styles.supportContainer,
                "flex flex-col gap-2",
              )}
            >
              <h6>Need Help?</h6>
              <p>Our team is here to guide you.</p>
              <CustomButton
                containerStyle={styles.customerBtn}
                Icon={Icons.ChatNotificationIcon}
                iconStyle={styles.icon}
                IconDirection="left"
                title="Contact Support"
                onClick={() => {
                  if (location.pathname.includes("/client")) {
                    navigate(routeConstant.client.contact.path);
                  } else if (location.pathname.includes("/collaborator")) {
                    navigate(routeConstant.collaborator.contact.path);
                  }
                }}
              />
            </div>
          )}
        </div>
        <div
          className={classNames(
            styles.userInfoContainerWrapper,
            "flex flex-col gap-3",
          )}
        >
          <div
            className={classNames(
              styles.userInfoContainer,
              "w-full flex items-center gap-2",
            )}
          >
            <span className={classNames(styles.userInfoIcon)}>
              {getUserInitials()}
            </span>
            <div>
              <h5>{user.display_name || "User"}</h5>
              <p>{getFormattedUserType()}</p>
            </div>
          </div>
          <div
            className={classNames(styles.navItemContainer, "pb-2")}
            onClick={handleOpenConfirmationModal}
          >
            <Icons.Logout className={classNames(styles.logoutIcon)} />
            <label
              className={classNames(
                styles.heading,
                styles.logout,
                "cursor-pointer",
              )}
            >
              Logout
            </label>
          </div>
        </div>
      </div>
      <ConfirmationModal
        show={openConfirmationModal}
        handleClose={handleCloseConfirmationModal}
        subtitle="Are you sure you want to logout?"
        actionButtonText="Yes, Logout"
        cancelButtonText="Not Now"
        handleSubmit={handleLogout}
      />
    </div>
  );
}
export default DashboardSidebar;
